import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as mediaStore from '../api/mediaStore';
import { Link } from 'react-router-dom';

export default function Serialylist() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // Always prefer live server state to avoid stale localStorage
        const r = await fetch('/api/popups', { cache: 'no-store' });
        if (r.ok) {
          const all = await r.json();
          const serials = (Array.isArray(all) ? all : []).filter(p => String(p.contentType||'') === 'serial');
          const mapped = serials.map(p => ({ id: String(p.id), title: p.title || 'Seriál', img: p.listThumb || p.heroImage || '', link: `/serialy?preview=${encodeURIComponent(String(p.id))}` }));
          if (mounted) setItems(mapped.map(ensureItemId));
          // also sync local cache for offline usage
          try { await mediaStore.setItems('serial', mapped); } catch {}
        } else {
          const raw = await mediaStore.getItems?.('serial') ?? [];
          if (mounted) setItems((raw || []).map(ensureItemId));
        }
      } catch {
        const raw = await mediaStore.getItems?.('serial') ?? [];
        if (mounted) setItems((raw || []).map(ensureItemId));
      }
      // run one-time cleanup on mount
      try { await cleanupOrphans(); } catch {}
    })();
    return () => { mounted = false; };
  }, []);

  // Refresh when catalog changes (synced from popup editor)
  useEffect(() => {
    const onCatalog = async () => {
      try { const arr = await mediaStore.getItems('serial'); setItems((arr||[]).map(ensureItemId)); } catch {}
    };
    window.addEventListener('catalog:changed', onCatalog);
    const onDeleted = async () => {
      try { const arr = await mediaStore.getItems('serial'); await cleanupOrphans((arr||[]).map(ensureItemId)); setItems((arr||[]).map(ensureItemId)); } catch {}
    };
    window.addEventListener('popup:deleted', onDeleted);
    return () => { window.removeEventListener('catalog:changed', onCatalog); window.removeEventListener('popup:deleted', onDeleted); };
  }, []);

  // Remove local serial items that are not linked to any popup
  async function cleanupOrphans(current) {
    try {
      const arr = Array.isArray(current) ? current : await mediaStore.getItems('serial');
      // keep only items with link like */?preview=<id>
      const withPreview = (arr||[]).filter(it => typeof it.link === 'string' && it.link.includes('preview='));
      const ids = withPreview.map(it => {
        try { const u = new URL(it.link, window.location.origin); return u.searchParams.get('preview'); } catch { return null; }
      }).filter(Boolean).map(String);
      if (!ids.length) {
        if ((arr||[]).length) await mediaStore.setItems('serial', []);
        return;
      }
      // verify against server popups
  const res = await fetch('/api/popups', { cache: 'no-store' });
      if (!res.ok) return; // if API fails, skip destructive changes
      const all = await res.json();
      const valid = new Set((Array.isArray(all) ? all : []).map(p => String(p.id)));
      const cleaned = (withPreview||[]).filter((it) => {
        try {
          const u = new URL(it.link, window.location.origin);
          const id = u.searchParams.get('preview');
          return id && valid.has(String(id));
        } catch { return false; }
      });
      await mediaStore.setItems('serial', cleaned);
    } catch (e) {
      // non-fatal
    }
  }
  // Legacy add/edit/context helpers removed – management is via Admin popup editor

  // Legacy context menu removed

  return (
    <Container>
      <h4 className="serialy">Seriály</h4>
      <Content>
        {items.map((it) => (
          <Card key={it.id}>
            <Wrap>
              {it.link && it.link.includes('preview=') ? (
                <div
                  className="prevent-select"
                  role="button"
                  tabIndex={0}
                  aria-label={it.title || 'item'}
                  onClick={() => {
                    try {
                      const url = new URL(it.link, window.location.href);
                      window.history.pushState({}, '', url.pathname + url.search);
                      const id = url.searchParams.get('preview');
                      window.dispatchEvent(new CustomEvent('preview:open', { detail: { id } }));
                    } catch (_) {}
                  }}
                >
                  <img className="hovimg" src={it.img || '/images/placeholder-thumb.png'} alt={it.title || ''} />
                </div>
              ) : it.link ? (
                <Link className="prevent-select" to={it.link} aria-label={it.title || 'item'}>
                  <img className="hovimg" src={it.img || '/images/placeholder-thumb.png'} alt={it.title || ''} />
                </Link>
              ) : (
                <div className="prevent-select" role="button" tabIndex={0} aria-label={it.title || 'item'}>
                  <img className="hovimg" src={it.img || '/images/placeholder-thumb.png'} alt={it.title || ''} />
                </div>
              )}
            </Wrap>
          </Card>
        ))}
      </Content>
    </Container>
  );
}

/* styled components (shaped stejně jako ve Filmylist.js) */

const Container = styled.div`
  font-size: 25px;
  padding: 0 42px;

  h4 {
    font-family: 'Noto Sans Lao', sans-serif;
    margin-bottom: 10px;
  }
`;

const Content = styled.div`
  display: grid;
  grid-gap: 20px;

  /* cílově 5 dlaždic v řádku na širších obrazovkách */
  grid-template-columns: repeat(5, minmax(180px, 1fr));

  /* postupné zmenšování sloupců při menších šířkách */
  @media (max-width: 1400px) {
    grid-template-columns: repeat(4, minmax(160px, 1fr));
  }
  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media (max-width: 800px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 420px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const Card = styled.div`
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: all 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  outline: 0px solid transparent;
  background: linear-gradient(rgb(48, 50, 62), rgb(30, 31, 42));
  transform-origin: center center; /* škálovat z centra */
  will-change: transform, box-shadow;

  img {
    inset: 0px;
    display: block;
    height: 100%;
    object-fit: cover;
    opacity: 1;
    position: absolute;
    width: 100%;
    z-index: 1;
    top: 0;
    -webkit-backface-visibility: visible;
    backface-visibility: visible;
    transform: none !important;
    transition: filter 180ms ease, opacity 180ms ease;
  }

  &:hover {
    outline: 3.2px solid #C7C7C7;
    box-shadow: rgb(0 0 0 / 90%) 0px 42px 64px -18px, rgb(0 0 0 / 76%) 0px 34px 24px -12px;
    transform: scale(1.035); /* škálovat z centra místo posunu */
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
  }
`;

const Wrap = styled.div`
  padding-top: 56.25%;
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: all 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  outline: 0px solid transparent;
  background: linear-gradient(rgb(48, 50, 62), rgb(30, 31, 42));
  transform-origin: center center;
  will-change: transform, box-shadow;

  img {
    inset: 0px;
    display: block;
    height: 100%;
    object-fit: cover;
    opacity: 1;
    position: absolute;
    width: 100%;
    z-index: 1;
    top: 0;
    -webkit-backface-visibility: visible;
    backface-visibility: visible;
    transform: none !important;
    transition: filter 180ms ease, opacity 180ms ease;
  }

  &:hover {
    outline: 3.2px solid #C7C7C7;
    box-shadow: rgb(0 0 0 / 90%) 0px 42px 64px -18px, rgb(0 0 0 / 76%) 0px 34px 24px -12px;
    transform: scale(1.035); /* škálovat z centra, aby nepohybovala nahoru */
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
  }
`;

const WrapAdd = styled.div`
  padding-top: 56.25%; /* stejný poměr jako Wrap */
  border-radius: 8px;
  background: rgba(255,255,255,0.02);
  border: 1px dashed rgba(255,255,255,0.06);
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: all 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  display: block;
  &:hover {
    background: rgba(255,255,255,0.03);
    transform: translateY(-3px);
  }
`;

/* vnitřní centrální kontejner absolutně umístěný nad "padding-top" plochou */
const AddInner = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #ccc;
`;

const AddPlus = styled.div`
  font-size: 32px;
  line-height: 1;
`;

const AddLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  margin-top: 6px;
`;

const Meta = styled.div`
  padding: 8px 4px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  color: #fff;
`;

const Label = styled.label`
  font-size: 12px;
  opacity: 0.85;
`;

const Input = styled.input`
  width: 100%;
  height: 40px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.06);
  background: rgba(255,255,255,0.02);
  color: #e6eef8;
  outline: none;
  font-size: 14px;
  box-sizing: border-box;

  /* jemnější fokus (bez silného modrého glow) */
  &:focus {
    box-shadow: none;
    border-color: rgba(255,255,255,0.12);
    background: rgba(255,255,255,0.02);
  }

  /* odstranit modrý autofill background v Chrome */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-internal-autofill-selected {
    -webkit-text-fill-color: #e6eef8 !important;
    -webkit-box-shadow: 0 0 0px 1000px rgba(255,255,255,0.02) inset !important;
    box-shadow: 0 0 0px 1000px rgba(255,255,255,0.02) inset !important;
  }
`;

const PreviewRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 6px;
`;

const PreviewImg = styled.img`
  width: 72px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid rgba(255,255,255,0.04);
`;

const PreviewText = styled.div`
  font-size: 13px;
  opacity: 0.8;
  color: #cfdff6;
  word-break: break-all;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 6px;
`;

const Btn = styled.button`
  min-width: 96px;
  padding: 8px 12px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 700;
  ${(p) => p.variant === 'primary' ? `
    background: linear-gradient(90deg,#1e90ff,#007bff);
    color: white;
  ` : `
    background: transparent;
    color: #cfdff6;
    border: 1px solid rgba(255,255,255,0.06);
  `}
`;

/* removed unused modal/context/image picker styles */

// místo: setItems(rawItems) -- normalizuj id hned po načtení
// přidej helper pro stabilní id
const ensureItemId = (it, idx) => {
  // uprav podle toho, kde máš skutečné id (_id, key, uid, apod.)
  const rawId = it.id ?? it._id ?? it.key ?? it.uid ?? idx;
  return { ...it, id: String(rawId) };
};

